import { createSlice, createAsyncThunk} from '@reduxjs/toolkit';

export const fetchPatients = createAsyncThunk(
    'patients/fetchPatients',
    async (_, thunkAPI) => {
        try{
            const res = await fetch('/api/v1/patients');
            if(!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();
            return data;
          }
          catch (err) {
            return thunkAPI.rejectWithValue(err.message)
          }
    }
);

const initialState = {
    list: [],
    loading: false,
    error:null,
    selected: null,
}

const patientSlice = createSlice({
    name: 'patients',
    initialState,
    reducers:{
        setSelectedPatient: (state, action) => {
            state.selected = action.payload;
        },
        clearSelectedPatient: (state) => {
            state.selected = null;
        },
        upsertPatient: (state, action) => {
            const patient = action.payload;
            const idx = state.list.findIndex((p) => p.id === patient.id);
            if (idx !== -1) {
                state.list[idx] = patient;
            }else {
                state.list.push(patient);
            }
        }
    },
 
    extraReducers: (builder) => {
        builder
            .addCase(fetchPatients.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPatients.fulfilled, (state, action) => {
                state.loading = false;
                state.list = action.payload;
            })
            .addCase(fetchPatients.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch patients';
            })
    }

     },
);
export const { upsertPatient, setSelectedPatient, clearSelectedPatient} = patientSlice.actions;
export const selectPatients = (state) => state.patients.list;
export const selectPatientsLoading = (state) => state.patients.loading;
export const selectPatientsError = (state) => state.patients.error;
export const selectSelectedPatient = (state) => state.patients.selected;

export default patientSlice.reducer;